import { render, staticRenderFns } from "./daibanli.vue?vue&type=template&id=7fb1a0da&scoped=true&"
import script from "./daibanli.vue?vue&type=script&lang=js&"
export * from "./daibanli.vue?vue&type=script&lang=js&"
import style0 from "./daibanli.vue?vue&type=style&index=0&id=7fb1a0da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb1a0da",
  null
  
)

export default component.exports